import React, { useContext, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { PapiGallection } from '@wix/da-papi-types';
import GalleryMultiselect from '../../../common/GalleryMultiselect';
import { SubmitFormContext } from '../../../context';
import { InitResponse } from '../../../redux/types';
import { useSubmitField } from '../../../hooks/useSubmitField';
import { initAdapter, submitAdapter } from './adapters';

interface Props {
  className?: string;
}

const GalleryFolderSelect: React.FC<Props> = ({ className }) => {
  const { t } = useTranslation();
  const initResponse = useContext(SubmitFormContext)?.initResponse;
  const { galleries: allGalleries = [], inGalleries = [] } =
    initResponse as InitResponse;

  const {
    id,
    error,
    field: { onChange },
    ref,
  } = useSubmitField('galleries', {
    initAdapter,
    submitAdapter,
  });

  const items = useMemo(() => {
    const isSelected = (gallery: PapiGallection) => {
      if (inGalleries.length > 0) {
        return inGalleries.some(g => g.folderId === gallery.folderId);
      }
      return false;
    };

    return allGalleries.map(gallery => ({
      gallery,
      value: `${gallery.folderId}`,
      selected: isSelected(gallery),
    }));
  }, [allGalleries, inGalleries]);

  return (
    <GalleryMultiselect
      className={className}
      id={id}
      label={t('originals.deviationSubmit.form.visibility.gallery.label')}
      placeholder={t(
        'originals.deviationSubmit.form.visibility.gallery.placeholder'
      )}
      error={error?.message}
      items={items}
      onChange={onChange}
      innerRef={el => {
        ref.current = el;
      }}
    />
  );
};
GalleryFolderSelect.displayName = 'GalleryFolderSelect';

export default GalleryFolderSelect;
